module.exports = __webpack_public_path__ + "img/ilustracao-sobre-complexo.520e60e7.png";